class SpinFooterEmail extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('details');
    this.details?.addEventListener('toggle', this.revealForm);
  }

  disconnectedCallback() {
    this.details?.removeEventListener('toggle', this.revealForm);
    cancelAnimationFrame(this.revealFrame);
  }

  revealForm = () => {
    cancelAnimationFrame(this.revealFrame);
    if (!this.details.open) return;

    this.revealFrame = requestAnimationFrame(() => {
      this.querySelector('form')?.scrollIntoView({
        block: 'center',
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      });
    });
  };
}

if (!customElements.get('spin-footer-email')) {
  customElements.define('spin-footer-email', SpinFooterEmail);
}
